/* @flow */

import React from "react";

import AggPopover from "platopulse/query_builder/components/AggregationPopover";

import type { Aggregation, ExpressionName } from "platopulse/meta/types/Query";
import type { TableMetadata } from "platopulse/meta/types/Metadata";

type Props = {
    aggregation?: Aggregation,
    tableMetadata: TableMetadata,
    customFields: { [key: ExpressionName]: any },
    onCommitAggregation: (aggregation: Aggregation) => void,
    onClose?: () => void,
    availableAggregations: [Aggregation],
    showOnlyProvidedAggregations: boolean
};

const AggregationPopover = (props: Props) => (
    <AggPopover {...props} aggregation={props.aggregation || []} />
);

export default AggregationPopover;



// WEBPACK FOOTER //
// ./qb/components/gui/AggregationPopover.jsx